import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 5000 } }

  connect() {
    this.poll()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  poll() {
    this.timer = setTimeout(async () => {
      try {
        const response = await fetch(this.urlValue, {
          headers: { "Accept": "text/html", "X-Requested-With": "XMLHttpRequest" }
        })
        if (!response.ok) return this.poll()

        const html = await response.text()
        const doc = new DOMParser().parseFromString(html, "text/html")
        const fresh = doc.querySelector(`[data-controller~="poll-refresh"]`)

        if (fresh) {
          this.element.innerHTML = fresh.innerHTML
          if (!fresh.dataset.pollRefreshUrlValue) return
        }

        this.poll()
      } catch {
        this.poll()
      }
    }, this.intervalValue)
  }
}
